import { IAuthenticatorProps } from 'aws-amplify-react/lib/Auth/Authenticator';
import React from 'react';

const AuthNote: React.FC<IAuthenticatorProps> = props => {
  return (
    <div style={{ color: '#304554', textAlign: 'center', marginTop: 24 }}>
      By continuing in I agree to the{' '}
      <a
        style={{ color: '#304554', textDecoration: 'underline' }}
        href="https://www.giide.com/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
      ,{' '}
      <a
        style={{ color: '#304554', textDecoration: 'underline' }}
        href="https://www.giide.com/terms-of-use"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Use
      </a>
      , and{' '}
      <a
        style={{ color: '#304554', textDecoration: 'underline' }}
        href="https://www.giide.com/creator-terms-of-use"
        target="_blank"
        rel="noopener noreferrer"
      >
        Creator Terms of Use
      </a>
      .
    </div>
  );
};

export default AuthNote;
